import { useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { railEquipmentTypeByActiveBySortKey } from "../../../../graphql/queries";
import { logError } from "../../../../utils/appUtils";

/**
 * Hook for fetching rail equipment types for track management.
 * Creates a lookup map: equipmentTypeId -> { name, length }
 *
 * @param {Function} setEquipmentTypeMap - Setter for equipment type map state
 * @param {Function} notify - Optional react-admin notify function for errors
 */
export const useEquipmentTypes = ({ setEquipmentTypeMap, notify }) => {
  useEffect(() => {
    const fetchEquipmentTypes = async () => {
      try {
        const reloadYardId = window.appUser?.reloadYardId;
        if (!reloadYardId) return;

        const railResponse = await API.graphql(
          graphqlOperation(railEquipmentTypeByActiveBySortKey, {
            reloadYardId,
            activeSortKey: { beginsWith: { active: "true" } },
            limit: 1000,
          }),
        );
        const railEquipmentTypes =
          railResponse?.data?.railEquipmentTypeByActiveBySortKey?.items || [];

        const lookupMap = {};
        railEquipmentTypes.forEach((type) => {
          if (type.id && type.name) {
            lookupMap[type.id] = {
              name: type.name,
              length: type.length != null ? Number(type.length) : null,
            };
          }
        });

        if (Object.keys(lookupMap).length > 0) {
          setEquipmentTypeMap(lookupMap);
        }
      } catch (err) {
        logError("useEquipmentTypes:fetchEquipmentTypes", err, notify);
      }
    };

    fetchEquipmentTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setEquipmentTypeMap]);
};
